<template>
  <Icon type="ios-arrow-down" size="14px"></Icon>
</template>

<script>
  export default {
    name: 'vue-treeselect--arrow',
  }
</script>
